const API_CONFIG = {
  local: "http://127.0.0.1:7860",
  hf: "https://haidersajjad-pdf-assistant-backend.hf.space",
  production: "https://haidersajjad-pdf-assistant-backend.hf.space", // fallback
};

const resolveEnvironment = () => {
  // Check for explicit environment variable FIRST (highest priority)
  const explicitEnv = process.env.REACT_APP_ENVIRONMENT;

  // Debug logging
  console.log("🔧 Environment Resolution Debug:");
  console.log("REACT_APP_ENVIRONMENT:", explicitEnv);
  console.log("Available API configs:", Object.keys(API_CONFIG));

  if (explicitEnv) {
    console.log("✅ Explicit environment variable found:", explicitEnv);
    // Support both 'local' and 'hf' values
    if (explicitEnv === "local" && API_CONFIG.local) {
      console.log("🏠 Using LOCAL backend");
      return "local";
    }
    if (explicitEnv === "hf" && API_CONFIG.hf) {
      console.log("☁️ Using HUGGING FACE backend");
      return "hf";
    }
    // If explicitEnv is set but not recognized, default to hf
    console.log("⚠️ Unrecognized environment, defaulting to HF");
    return "hf";
  }

  // Only use auto-detect if NO environment variable is set
  console.log("🔍 No environment variable, using auto-detection");
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    console.log("Current hostname:", host);
    if (host === "localhost" || host === "127.0.0.1") {
      console.log("🏠 Auto-detected LOCAL environment");
      return "local";
    }
  }

  // Default to hf (Hugging Face) if no env found
  console.log("☁️ Defaulting to HUGGING FACE backend");
  return "hf";
};

// Get the current API base URL based on environment
export const getApiUrl = () => {
  const manualBaseUrl = process.env.REACT_APP_API_BASE_URL;
  if (manualBaseUrl) {
    console.log("🔧 Using manual API URL:", manualBaseUrl);
    return manualBaseUrl;
  }

  const environment = resolveEnvironment();
  const apiUrl = API_CONFIG[environment] ?? API_CONFIG.hf;
  console.log("🌐 Final API URL:", apiUrl, "(environment:", environment + ")");
  return apiUrl;
};

const config = {
  api: API_CONFIG,
  resolveEnvironment,
};

export default config;
